<template>
  <div class="downqrcode-popup">
    <van-popup position="center" v-model="showQRCodePopup"  class="qrcode-popup" :close-on-click-overlay="false">
      <div @click.stop="" class="qrcode-container">
        <div class="qrcode-text">扫码下载app端体验完整功能</div>
        <div class="qrcode-box">
          <img src="@/assets/image/h5img/qr.png" class="qrcode-image" style="width: 140px;height:140px"/>
        </div>
        <single-button text="返回首页" @know="close" width="230px" height="40px" fontSize="14px"></single-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'VueNew39DownqrcodePopup',

  data() {
    return {
      showQRCodePopup: false,
    };
  },

  mounted() {
    
  },

  methods: {
    open(){
      this.showQRCodePopup = true;
    },
    close(){
      this.showQRCodePopup = false;
      this.$router.replace('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.downqrcode-popup{
  .van-popup{
    z-index: 99999 !important;
  }
  ::v-deep .van-overlay{
    z-index: 99998 !important;
  }
}
.van-popup{
  width: 310px;
  height: 270px;
  background: linear-gradient( 180deg, #FFF3D4 0%, #FFFFFF 40%);
  border-radius: 10px 10px 10px 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.qrcode-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  img{
    display: block;
    margin: 15px auto;
  }
  .qrcode-text{
    font-weight: 700;
    font-size: 16px;
  }
}
</style>